// extracted by mini-css-extract-plugin
export default {"benefitCard":"BenefitCard_benefitCard__zidc+","benefitCard__image":"BenefitCard_benefitCard__image__O2XbO","benefitCard__content":"BenefitCard_benefitCard__content__WIOGn"};